import React  from "react";

const EditCard =() =>{
return <>
          
             
              
<div className="outer-edit-card ">

<div className="edit-card-title ">
<div className="text-line-extra-small-card "></div> 
</div> 
<div className="edit-card-button ">
 
<span className="edit-card-value ">  <div className="text-line-extra-small-card "></div> 
</span>   

<div className="edit-button" 

></div>


</div>


</div>                           
              
              
              
              
              
              </>
}

export default EditCard;